import React, {Component} from 'react'
import withStyles from '@mui/styles/withStyles'
import Grid from '@mui/material/Grid'
import {withNamespaces, Trans} from 'react-i18next'
import AppContext from '../../../Common/contexts/AppContext'
import PropTypes from 'prop-types'
import {Paper, Typography, Button} from '@mui/material'
import messages from '../../../../assets/messages'
import Amount from '../../../Common/Amount'
import {isMobile} from '../../../../common/utils'
import classNames from 'classnames'
import {get} from 'lodash'
import LockOutlined from '@mui/icons-material/LockOutlined'
import JdenticonImage from '../../../Common/JdenticonImage'

const fontRatio = isMobile() ? 0.5 : 0.7
const styles = theme => ({
  amountGreen: {
    color: theme.palette.green.color,
  },
  amountRed: {
    color: theme.palette.red.color,
  },
  amount: {
    marginTop: isMobile() ? 2 : 5,
    display: 'block',
  },
  amountCurrency: {
    fontSize: Math.floor(24 * fontRatio),
    fontWeight: 300,
    padding: '0 3px',
  },
  amountValue: {
    fontSize: Math.floor(36 * fontRatio),
    fontWeight: 300,
  },
  amountFraction: {
    fontSize: Math.floor(24 * fontRatio),
    fontWeight: 300,
  },
  financialInfoItem: {
    marginTop: 0,
    textAlign: 'left',
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  copyTradingBtn: {
    marginTop:  isMobile() ? '1rem' : 0,
    marginLeft: 10,
    padding: 0,
    textAlign: 'center',
  },
  strategiesPaper: {
    padding: 10,
  },
  strategyCardItem:{
    marginTop: isMobile() ? 2 : 5,
    display: 'block',
    fontSize: Math.floor(36 * fontRatio),
    fontWeight: 300,
  },
  strategyCardItemGreen:{
    color: theme.palette.green.color,
  },
  strategyCardItemRed:{
    color: theme.palette.red.color,
  },
  copying: {
    color: theme.palette.green.color,
    fontWeight: 400,
  },
  smallerFont:{
    fontSize: 16
  },
  loss: {
    color: theme.palette.red.color,
  },
  profit: {
    color: theme.palette.green.color,
  },
  textBlue: {
    color: theme.palette.primary.main
  },
  textCaption: {
    color: theme.palette.grey.color
  },
  main: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 20
    },
  },
  passwordProtected: {
    paddingTop: 5,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0
    },
  },
  lockIcon: {
    fontSize: 16,
    marginRight: 5,
    marginBottom: -3
  },
  strategyIcon: {
    borderRadius: '50%',
    verticalAlign: 'middle',
    overflow: 'hidden',
    'object-fit': 'cover',
    width: 56,
    height: 56,
    '&:hover':{
      backgroundColor: 'transparent'
    },
  },
  imageCropper: {
    width: 56,
    height: 56,
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '50%',
  }
})

class StrategyCard extends Component {
  static contextType = AppContext

  constructor(props) {
    super(props)
    this.state = {
      status: '',
      loading: false,
      preview: get(props, 'strategy.strategyAvatar', ''),
    }
  }

  render() {
    const {classes, strategy, onClick, account, onStop, hasOpenPositions} = this.props
    const {preview} = this.state
    const copyTradingDetails = account.copyTrading

    const disableOtherBtns = copyTradingDetails && (copyTradingDetails.isActive ||
      (!copyTradingDetails.isActive && copyTradingDetails.startRequestedDate && !copyTradingDetails.stopCopyingDate))

    const activeCopyingStrategy = copyTradingDetails && (strategy.login === copyTradingDetails.accountCopying.remoteId)
      && copyTradingDetails.isActive

    const enableStopBtn = activeCopyingStrategy

    const stopAlreadyRequested = copyTradingDetails && (strategy.login === copyTradingDetails.accountCopying.remoteId)
      && copyTradingDetails.stopRequestedDate && !copyTradingDetails.stopCopyingDate

    const stopBtnAction = activeCopyingStrategy && onStop ? () => onStop(copyTradingDetails) : ()=>{}

    const disableAction = !enableStopBtn && (account.isReadOnly || (hasOpenPositions && strategy.performanceFee>0) || !!account.credit)
    const disabledButton = !!(stopAlreadyRequested || disableOtherBtns|| disableAction)
    const renderButton = <div>
      <Button
        id='loadingButton'
        onClick={() => onClick && onClick(strategy)}
        autoFocus
        color="primary"
        variant={!isMobile() ? 'contained' : 'text'}
        size="medium"
        disabled={disabledButton}
      >
        <Trans {...messages.startCopying}/>
      </Button>
      {!disabledButton && get(strategy, 'protectedPassword') && <Typography variant='caption' className={classes.passwordProtected}>
        <LockOutlined className={classes.lockIcon}/>
        <Trans {...messages.passwordProtected} />
      </Typography>}
    </div>
    const altName = get(strategy, 'accountName') || get(strategy, 'login')
    return <Grid container>
      <Grid item xs={12}>
        <Paper className={classes.strategiesPaper}>
          <Grid container direction='row' justifyContent='space-between' alignItems='center'>
            <Grid item className={classNames(classes.financialInfoItem, classes.main)} xs={isMobile() ? 6 : 'auto'}>
              {!preview &&  <JdenticonImage accountName={altName} size={'56'} />}
              {preview && <div className={classes.imageCropper}>
                <img src={preview} alt={altName} width="56" height="56" className={classes.strategyIcon}/>
              </div>}
            </Grid>
            <Grid item className={classNames(classes.financialInfoItem, classes.main)} xs={isMobile() ? 6 : 'auto'}>
              <Typography variant='body1' className={classes.textBlue}>{strategy.accountName}</Typography>
              <Typography variant='caption' className={classes.textCaption}>
                {strategy.performanceFee}% <Trans {...messages.performanceFee} />
              </Typography>
              <Typography variant='caption' className={classes.textCaption}>
                <Trans {...messages.activeSince} /> {strategy.activeSince}
              </Typography>
            </Grid>
            <Grid item className={classes.financialInfoItem} xs={isMobile() ? 6 : 'auto'}>
              <Typography variant='caption'><Trans {...messages.totalTrades} /></Typography>
              <Typography variant='body1' className={classes.strategyCardItem}>{strategy.numTrades}</Typography>
            </Grid>
            <Grid item className={classes.financialInfoItem} xs={isMobile() ? 6 : 'auto'}>
              <Typography variant='caption'><Trans {...messages.winningTrades} /></Typography>
              <Typography variant='body1' className={classNames(classes.strategyCardItem, classes.strategyCardItemGreen)}>{strategy.winningTrades}</Typography>
            </Grid>
            <Grid item className={classes.financialInfoItem} xs={isMobile() ? 6 : 'auto'}>
              <Typography variant='caption'><Trans {...messages.losingTrades} /></Typography>
              <Typography variant='body1' className={classNames(classes.strategyCardItem, classes.strategyCardItemRed)}>{strategy.losingTrades}</Typography>
            </Grid>
            <Grid item className={classes.financialInfoItem} xs={isMobile() ? 6 : 'auto'}>
              <Typography variant='caption'><Trans {...messages.closedProfit} /></Typography>
              <Amount
                value={strategy.totalProfit} currency={strategy.currency} locale='en-US' classes={{
                  root: strategy.totalProfit < 0 ? classes.loss : classes.profit,
                  currency: classes.amountCurrency,
                  value: classes.amountValue,
                  fraction: classes.amountFraction
                }} />
            </Grid>
            <Grid item className={classes.financialInfoItem} xs={isMobile() ? 6 : 'auto'}>
              <Typography variant='caption'><Trans {...messages.roi} /></Typography>
              <Typography variant='body1' className={classes.strategyCardItem}>{Math.ceil(strategy.roi)}<span className={classes.smallerFont}>%</span></Typography>
            </Grid>
            {!enableStopBtn && <Grid item className={classes.copyTradingBtn} xs={isMobile() ? 12 : 'auto'}>
              {stopAlreadyRequested && <Typography variant='caption'><Trans {...messages.pending} /></Typography>}
              {renderButton}
            </Grid>}
            {enableStopBtn && <Grid item className={classes.copyTradingBtn} xs={isMobile() ? 12 : 'auto'}>
              <Typography variant='caption' className={classes.copying}><Trans {...messages.copying} /></Typography>
              <Button
                id='loadingButton'
                className={!isMobile() ? classes.stopTradingBtn : ''}
                onClick={stopBtnAction}
                autoFocus
                color={!isMobile() ? 'secondary' : 'primary'}
                variant={!isMobile() ? 'contained' : 'text'}
                size="medium"
                disabled={!!(stopAlreadyRequested) || disableAction}
              >
                {enableStopBtn ? <Trans {...messages.stopCopying}/> : <Trans {...messages.startCopying}/>}
              </Button>
              {stopAlreadyRequested && <Typography variant='caption'><Trans {...messages.pending} /></Typography>}
            </Grid>}
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  }
}

StrategyCard.propTypes = {
  strategy: PropTypes.object,
  account: PropTypes.object,
  onClick: PropTypes.func,
  onStop: PropTypes.func,
}
export default withStyles(styles, {withTheme: true})(withNamespaces()(StrategyCard))
